export async function downloadFile(url: string, filename?: string) {
  // For download use the original URL
  const urlToDownload = url.replace("-scaled", "");
  const response = await fetch(
    `/api/download-media?url=${encodeURIComponent(urlToDownload)}`,
  );
  if (response.status !== 200) {
    throw new Error(`Failed to download media: ${response.statusText}`);
  }
  const blob = await response.blob();
  const urlObject = URL.createObjectURL(blob);
  const a = document.createElement("a");
  filename =
    filename?.replace("-scaled", "") ||
    urlToDownload.split("/").pop() ||
    "download";
  a.href = urlObject;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  URL.revokeObjectURL(urlObject);
  document.body.removeChild(a);
}
